import { Controller } from "@hotwired/stimulus"

// Handles add/remove of nested form fields (installments, zones, plans, activities, discounts, reminders)
export default class extends Controller {
  static targets = ["list", "template", "fields", "total"]

  add(event) {
    event.preventDefault()
    const template = this.templateTarget
    const content = template.innerHTML.replace(/new_record/g, new Date().getTime())
    this.listTarget.insertAdjacentHTML("beforeend", content)
    // Les <i data-lucide> insérés ici n'ont jamais été convertis en SVG :
    // `createIcons` ne tourne qu'au chargement et sur les événements Turbo, et
    // `insertAdjacentHTML` n'en déclenche aucun. Le bouton de suppression des
    // cartes ajoutées à la volée était un carré vide.
    window.g4sRenderIcons?.()
    this.updateCount()
  }

  remove(event) {
    event.preventDefault()
    const fieldsEl = event.target.closest("[data-fee-nested-fields-target='fields']")
    if (!fieldsEl) return

    const destroyInput = fieldsEl.querySelector("input[name*='_destroy']")
    if (destroyInput) {
      destroyInput.value = "1"
      fieldsEl.style.display = "none"
    } else {
      fieldsEl.remove()
    }
    this.updateCount()
    this.updateTotal()
  }

  updateCount() {
    if (!this.hasTotalTarget) return
    const visibleFields = this.fieldsTargets.filter(f => f.style.display !== "none")
    this.totalTarget.textContent = visibleFields.length
  }

  updateTotal() {
    if (!this.hasTotalTarget) return
    const visibleFields = this.fieldsTargets.filter(f => f.style.display !== "none")
    const total = visibleFields.reduce((sum, field) => {
      const amountInput = field.querySelector("input[name*='amount']") ||
                          field.querySelector("input[name*='monthly_amount']")
      return sum + (parseFloat(amountInput?.value) || 0)
    }, 0)
    this.totalTarget.textContent = `${total.toLocaleString()} F CFA`
  }

  // Called on amount input changes
  amountChanged() {
    this.updateTotal()
  }
}
